import constants from '../../constants';
import React, { createRef } from 'react';
import Contact from '../../Model/contact';
import TableView from '../tableView';
import { reactFormatter } from 'react-tabulator';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import Company from '../../Model/company';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { AxiosResponse } from 'axios';
import { useTranslation } from 'react-i18next';
import { Container, Modal, Row, Button, Col } from 'react-bootstrap';
import {
  Tooltip,
  IconButton
} from '@mui/material';
import { deleteContactCompany } from '../../api/contacts';
import '../../pages/Contacts/contacts.css';


interface CompaniesListProps {
  showModal: boolean;
  hideModal: () => void;
  contact: Contact;
  selectCompany: Function;
}

function ContactsCompaniesActions(context: any) {
  const cellData = context.cell.getData();
  return (
    <>
      <Tooltip
        id={'edit'}
        placement="top"
        title={context.props.t('EDIT_COMPANY')}
      >
        <IconButton
          style={{ marginLeft: 15 }}
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
            context.props.selectCompany(cellData);
            context.props.refreshTable();
          }}
        >
          <EditOutlinedIcon color="success" />
        </IconButton>
      </Tooltip>
      <Tooltip
        id={'delete'}
        placement="top"
        title={context.props.t('DELETE_COMPANY')}
      >
        <IconButton
          style={{ marginLeft: 15 }}
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
            context.props.deleteCompany(cellData, context.props.contact);
            context.props.refreshTable();
          }}
        >
          <DeleteOutlineOutlinedIcon color="error" />
        </IconButton>
      </Tooltip>
    </>
  );
}

export const CompaniesList = ({
  showModal,
  hideModal,
  contact,
  selectCompany
}: CompaniesListProps) => {
  const { t } = useTranslation();
  const id = contact?.id;
  const tabulator = createRef<TableView>();

  const refreshTable = () => {
    (tabulator?.current as any)?.tabulator?.current?.table?.replaceData();
  };

  const deleteCompany = async (company: Company, contactValue: Contact) => {
    // eslint-disable-next-line no-restricted-globals
    if ( confirm( `Sei sicuro di voler eliminare l\'azienda "${company?.business_name}"?` )
    ) {
      try {
        const result: AxiosResponse = await deleteContactCompany(
          contactValue?.id,
          company?.id
        );
        console.log(result);
        if (result.data.success) {
          refreshTable();
        }
      } catch (error) {
        console.error(error);
      }
    }
  };

  const columns = [
    { title: t('ID'), field: 'id', visible: false },
    {
      title: t('BUSINESS_NAME'),
      field: 'business_name',
      sorter: 'string',
      headerFilter: 'input'
    },
    {
      title: t('VAT'),
      field: 'vat',
      sorter: 'string',
      headerFilter: 'input'
    },
    {
      title: '',
      sortable: false,
      formatter: reactFormatter(
        <ContactsCompaniesActions
          props={{
            contact: contact,
            selectCompany: selectCompany,
            deleteCompany: deleteCompany,
            refreshTable: refreshTable,
            t: t
          }}
        />
      ),
      headerSort: false,
      widthShrink: 0
    }
  ];

  return <><Modal show={showModal} keyboard={true} size='xl' onHide={hideModal}>
  <Modal.Header>
    <Modal.Title>{t('COMPANY_LIST')}</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <Container>
      <Row className='w-100 justify-content-center'>
        <Col>
          <Button onClick={() => selectCompany({})}>
            {t('ADD_COMPANY')}
          </Button>
          <TableView t={t} ref={tabulator} api={constants.api.getCompaniesByContact.replace(':id', `${id}`)}
            columns={columns}
            id={'contact-companies-list'}
          />
        </Col>
      </Row>
    </Container>
  </Modal.Body>
</Modal></>;
};

